
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In den ersten beiden Tagen nach der Geburt erhält Erika Milch von ihrer Mutter, sogenannte Biestmilch. Diese stärkt das Abwehrsystem des Jungtiers.
Danach trinkt sie bis zur dritten Woche 5 bis 6 Liter Milch von irgendwelchen Kühen im Stall. Erika lebt in einem Anbindestall, so wie rund die Hälfte
der Kühe in der Schweiz. Immer mehr Bauernbetriebe stellen allerdings auf Laufställe um. In den ersten vier Monaten darf der Bauer Erika nicht anbinden.`}</p>
    <p>{`Erika ist eine Milchkuh. Da hat sie nochmals Glück gehabt. Erika hätte auch ein Mastkalb sein können. Mastkälber verlassen bereits nach rund drei Wochen ihren
Geburtsort. Sie werden auf Mastbetrieben zusammen mit gleichaltrigen Kälbern gehalten, gemästet und im Alter von höchstens 7 Monaten getötet.
2018 wurden 217'088 Kälber geschlachtet – eins alle 2,4 Minuten. Kalbfleisch macht 6 Prozent des Schweizer Fleischkonsums aus.
Die meisten männlichen Kälber verwendet man für die Kälbermast. Nur wenige werden zum Zuchtstier (Muni) aufgezogen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;